var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{staticClass:"ma-0 pa-0",attrs:{"cols":"12","md":"12"}},[_c('div',{staticClass:"video-wrapper",style:({
      height: _vm.$vuetify.breakpoint.smAndDown ? '72vh' : '100vh',
      width: '100%'
    })},[_c('video',{key:new Date().toString(),attrs:{"loop":"","autoplay":"","muted":"","playsinline":"","id":"myVideo","height":_vm.$vuetify.breakpoint.smAndDown ? '72vh' : '700px'},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.video,"type":"video/mp4"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }